import { render, staticRenderFns } from "./BillItemCard.vue?vue&type=template&id=208871b6"
import script from "./BillItemCard.vue?vue&type=script&lang=ts"
export * from "./BillItemCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports